export const adFormats = ['Image or Video', 'Carousel', 'Nub (Reel / Story)'];
